import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { loadAnalytics } from '@/lib/analytics';

const STORAGE_KEY = 'sp_cookie_consent_v2';
export const getCookieConsent = () => {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY))?.value || null; }
  catch { return null; }
};

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  useEffect(() => { setVisible(!getCookieConsent()); }, []);
  const choose = (value) => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ value, timestamp: new Date().toISOString() })); }
    catch (err) { console.warn('Cookievalg kunne ikke gemmes:', err); }
    if (value === 'accepted') loadAnalytics();
    setVisible(false);
  };
  if (!visible) return null;
  return (
    <aside className="cookie-panel" aria-label="Cookievalg" data-testid="cookie-banner">
      <p>Vi bruger nødvendige cookies. Med dit samtykke bruger vi også Google Analytics og Meta Pixel til statistik og markedsføring. <Link to="/privatlivspolitik" data-testid="cookie-privacy-link">Læs mere</Link>.</p>
      <div className="cookie-actions">
        <button type="button" onClick={() => choose('rejected')} data-testid="cookie-reject">Afvis valgfri</button>
        <button type="button" onClick={() => choose('accepted')} data-testid="cookie-accept">Accepter</button>
      </div>
    </aside>
  );
}